module.exports = __webpack_public_path__ + "files/Trustami_TWS_Bachelor_Master_Thesis__Deep_Learning_in_Content_Curation.pdf";